import { Component, OnInit, Input } from '@angular/core';
import { SetService } from 'ngx-block-core';
import { selectOperation, selectSize, selectThemeSize, iconTheme } from "../../../data/data";
import { NzModalService, NzMessageService } from 'ng-zorro-antd';
@Component({
    selector: 'app-sucu05-button0010005',
    templateUrl: './sucu05-button0010005.component.html',
    styles: [
        `
    [nz-button] {
      margin-right: 8px;
      margin-bottom: 12px;
    }
  `
    ]
})
export class Sucu05Button0010005Component implements OnInit {
    @Input() local = false;
    @Input() static = false;
    @Input() blockid = "-1";
    @Input() layoutid = "-1";
    @Input() sets = {
        blockCode: "sucublock16",
        blockId: "",
        blockName: "保存按钮",
        layoutId: "",
        blockType: 'formButton',
        blockChildType: '',
        versionCode: 3,
        styles: {
            nzText: "保存",
            nzType: "default",
            nzSize: "default",
            nzBgColor: "",
            nzIcon: {
                nzIconType: '',
                nzIconTheme: '',
                nzIconColor: '',
            },
            nzOpen: true

        },
        datas: {
            nzDataSource: "",
            nzJumpPage: "",
            nzOperateType: "return",
        }
    };
    setData = [];
    setDataInit() {
        this.setData = [
            {
                tabName: '数据',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            { name: 'nzDataSource', }
                        ]
                    }
                ]
            },
            {
                tabName: '操作',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            {
                                name: 'select',
                                inputs: {
                                    nzText: "操作方式 : ", nzKeys: ['datas', 'nzOperateType'], nzData: selectOperation
                                }
                            },
                        ]
                    },
                ]
            },
            {
                tabName: '样式',
                datas: [
                    {
                        type: 'styles',
                        data: [
                            {
                                name: 'input',
                                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
                            },
                            {
                                name: 'input',
                                inputs: {
                                    nzText: "按钮名称 : ", nzKeys: ['styles', 'nzText']
                                }
                            },
                            {

                                name: 'select',
                                inputs: {
                                    nzText: "主题 : ", nzKeys: ['styles', 'nzType'], nzData: selectThemeSize
                                }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "图标主题:", nzKeys: ['styles', 'nzIcon', 'nzIconTheme'], nzData: iconTheme, },
                                outputs: {
                                    ngModelChange: (event) => {


                                        if (event == 'twotone') {

                                            this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = true;

                                        } else {
                                            this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = false;

                                        }


                                        this.setService.onReLoadbBlock(this.layoutid);

                                    }
                                }
                            },
                            {
                                name: 'input',
                                inputs: { nzText: "图标 : ", nzKeys: ['styles', 'nzIcon', 'nzIconType'], nzPopContent: ['填入type,请参照官方文档:', 'https://ng.ant.design/components/icon/zh'] },
                                outputs: { ngModelChange: () => { if (this.sets.styles.nzIcon.nzIconType == '') this.setService.onReLoadbBlock(this.layoutid) } }
                            },
                            {
                                name: 'color', show: this.sets.styles.nzIcon.nzIconType == 'twotone',
                                inputs: {
                                    nzText: "图标颜色 : ", nzKeys: ['styles', 'nzIcon', 'nzIconColor']
                                }
                            },
                            {
                                name: 'color',
                                inputs: {
                                    nzText: "背景颜色 : ", nzKeys: ['styles', 'nzBgColor']
                                }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "开放按钮 : ", nzKeys: ['styles', 'nzOpen'] }
                            },
                        ]
                    },
                ]
            }
        ]

    }



    constructor(
        public setService: SetService,
        private message: NzMessageService,
        private modalService: NzModalService,
    ) { }
    ngOnInit() {
        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== '{}') {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;
                this.autoUpdate();
                this.setDataInit();
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }
                
            }
            else {//静态
                if(typeof this.sets=="string")
        this.sets = JSON.parse(<any>this.sets);
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
                this.autoUpdate();
            }
        }


    }

    autoUpdate() {

        //v2,升级自定义表单参数
        if (this.sets.versionCode < 2) {

            this.sets.blockCode = "sucublock16";

            this.sets.versionCode = 2;
        }
        // V3 按钮开放
        if (this.sets.versionCode < 4) {

            this.sets.styles['nzOpen'] = true;

            this.sets.versionCode = 4;
        }

    }

    onClick() {
        if (!this.sets.styles.nzOpen) {
            this.message.create('info', `功能暂未开放`);
        } else {

        }
    }

}
